<template lang="pug">
SlideInPanel(:isOpen="sidePanelIsOpen" @close="$emit('close')")
  SlideInBaseTemplate(
    v-if="focusedItem"
    :title="focusedItem.InternalName"
    :allowEdit="allowEdit"
    @edit="event => $emit('edit', {item: focusedItem, event})"
    @close="$emit('close')"
  )
    BriqTable.dense
      tbody
        tr(data-test-id="deal-key")
          td.bold Key
          td {{ focusedItem.Key }}
        tr(data-test-id="deal-name")
          td.bold Deal name
          td {{ focusedItem.InternalName }}
        tr(v-if="hasUrl" data-test-id="deal-funnel-url")
          td.bold Funnel URL
          td 
            a(:href="focusedItem.FunnelUrl" target="_blank") {{focusedItem.FunnelUrl}}
        tr(data-test-id="deal-price")
          td.bold Price
          td {{ displayPrice }}
        tr(data-test-id="deal-min-participants")
          td.bold Min. participants
          td {{ focusedItem.MinPersons }}
        tr(data-test-id="deal-max-participants")
          td.bold Max. participants
          td {{ focusedItem.MaxPersons }}
        tr(data-test-id="deal-status")
          td.bold Status
          td {{ status }}
        tr(v-if="hasError" data-test-id="deal-error")
          td.bold Problems
          td.text(v-html="errors")
</template>

<script>
import { pipe, ifElse, prop } from 'ramda'
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import SlideInBaseTemplate from '@v/components-global/layout/SlideInBaseTemplate.vue'

export default {
  name: 'DealSlideInPanel',
  components: { SlideInPanel, SlideInBaseTemplate },
  props: {
    focusedItem: Object,
    sidePanelIsOpen: Boolean,
    allowEdit: Boolean,
  },
  computed: {
    displayPrice() {
      const priceString = pipe(
        ifElse(prop('DisplayIncludingTax'), prop('IncludingTax'), prop('ExcludingTax')),
        this.$formatCurrency,
      )(this.focusedItem.Price)
      const incExcTax = this.focusedItem.Price.DisplayIncludingTax
        ? 'including tax'
        : 'excluding tax'
      return `${priceString} (${incExcTax})`
    },
    availableOnline() {
      return this.focusedItem.AvailableOnline ? 'Yes' : 'No'
    },
    status() {
      return this.focusedItem.Enabled ? 'Active' : 'Inactive'
    },
    hasUrl() {
      return this.focusedItem.FunnelUrl !== null
    },
    hasError() {
      return this.focusedItem.ObjectError !== null
    },
    errors() {
      return this.focusedItem.ObjectError.Details.replace('\n', '<br/>')
    },
  },
}
</script>
